// extracted by mini-css-extract-plugin
module.exports = {"cellth":"TableHeadCell_cellth__1m4SV","cellContent":"TableHeadCell_cellContent__31ZXQ","cellImage":"TableHeadCell_cellImage__3j933"};